import React, { useCallback, useContext, useEffect, useState } from "react";
import "./styles.css";
import { Button, Spinner } from "@chakra-ui/react";
import { DatePicker, ModelPicker } from "../../Components/Molecules";
import { Sheet } from "../../Templates";
import { PANELS, processWidgetData, WIDGET_TYPES } from "../../Library/widgets";
import { StoreContext } from "../../Library/contexts";
import { DATE_RANGES } from "../../Library/constants";
import { getWidgetData } from "../../APIs";

const ANALYTICS_LAYOUT = [
  [ WIDGET_TYPES.MOTOR_HEALTH, WIDGET_TYPES.AVERAGE_RUNNING ],
  [ WIDGET_TYPES.BATTERY_HEALTH ],
  [ WIDGET_TYPES.THROTTLE_PERCENT ],
]

const Analytics = ({ accessCodes }) => {
  const { filters } = useContext(StoreContext);
  const [ isLoading, setIsLoading ] = useState(true);
  const [ statistics, setStatistics ] = useState({});

  const handleApply = useCallback(async () => {
    if (statistics.range === DATE_RANGES[filters.range] && statistics.models === filters.models) return;

    setIsLoading(true);
    const analytics = await getWidgetData(DATE_RANGES[filters.range], PANELS.ANALYTICS, filters.models);
    setStatistics({ range: DATE_RANGES[filters.range], models: filters.models, data: processWidgetData(analytics) });
    setIsLoading(false);
  }, [ statistics, filters ]);

  useEffect(() => {
    if (!statistics.data) handleApply();
  }, [ statistics, handleApply ]);

  return (
    <section className="panel-main">
      <header className="panel-filters">
        <ModelPicker />
        <DatePicker />
        <Button className="panel-button" onClick={handleApply}>Apply</Button>
      </header>

      <main>
        {!isLoading ? <Sheet layout={ANALYTICS_LAYOUT} data={statistics.data} /> : (
          <div className="widget-loader">
            <Spinner />
          </div>
        )}
      </main>
    </section>
  );
};

export default Analytics;